import { Star, Quote } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const REVIEWS = [
  {
    quote: "They remodeled our kitchen and I never once had to chase them down. Showed up when they said, cleaned up every night, and the tile work is dead straight.",
    name: "Sample Homeowner",
    location: "Kitchen Remodel",
  },
  {
    quote: "Two other crews ghosted us on our deck. TCB had a written estimate the next morning and the composite deck done in under two weeks. Our backyard finally works.",
    name: "Sample Homeowner",
    location: "Custom Deck",
  },
  {
    quote: "Storm took out our roof and a 60-foot oak. One call handled both — new roof, tree off the fence line, and every scrap hauled away. Unreal follow-through.",
    name: "Sample Homeowner",
    location: "Roofing & Trees",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-20 md:py-32">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-16">
        <SectionHead
          eyebrow="Word of mouth"
          title="Neighbors talk. We listen."
          sub="Most of our work comes from referrals — here's what that sounds like."
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-14">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={i * 0.08} className="h-full">
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full flex flex-col bg-ink-card border border-line clip-notch-sm p-8 transition-colors duration-300 hover:border-safety/50"
              >
                <div className="flex items-center justify-between">
                  <div className="flex gap-1" aria-label="5 out of 5 stars">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="w-4 h-4 text-safety fill-safety" />
                    ))}
                  </div>
                  <Quote className="w-6 h-6 text-line" aria-hidden="true" />
                </div>
                <blockquote className="text-bone/90 text-base leading-relaxed mt-6 flex-1">"{r.quote}"</blockquote>
                <figcaption className="mt-8 pt-6 border-t border-line">
                  <p className="font-cond font-bold uppercase text-lg tracking-wide text-bone">{r.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-safety font-bold mt-1">{r.location}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
